var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFrench = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h640v480H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000091",
  d: "M0 0h213.3v480H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#e1000f",
  d: "M426.7 0H640v480H426.7z"
})));
export { SvgFrench as ReactComponent };
export default __webpack_public_path__ + "assets/images/french.c51154d10e2e1f3c5351850ae6f42f8f.svg";